import React, { useEffect, useState } from "react";
import "./CheckoutPage.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { maintainCartdata } from "../../home/redux/actions";
import { maintanCheckoutpage } from "../../home/redux/actions";
import { maintainFlatstreet } from "../../home/redux/actions";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import {
  formatPhoneNumber,
  formatPhoneNumberturkish,
} from "../../comman/components/TimeSence";
import { getRequestcall } from "../../comman/util/getRequest";
import { CART_DETAIL, GET_DISTANCE } from "../../constants/apiurl";
import BannercartPage from "../../comman/components/BannercartPage";
import {CurrentorderlistPage} from "../../comman/components/CurrentorderlistPage";
import { OrdersummaryPage } from "../../comman/components/CurrentorderlistPage";
import ButtonPage from "../../comman/button/ButtonPage";
import FormgroupPage, { FormControl, FormLabel } from "./../../comman/formgroup/FormgroupPage"
import AutocompletePlace from "../../comman/components/AutocompletePlace";

function CheckoutPage(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [cardInput, setCardInput] = useState({
    fullname: "",
    company_name: "",
    lat: "",
    lng: "",
    address: "",
    country: "",
    city: "",
    flat: "",
    street: "",
    postcode: "",
    phone: "",
    email: "",
    order_note: "",
    country_code: "+90",
  });
  const [errorMsg, setErrormsg] = useState({
    fullname: "",
    address: "",
    country: "",
    flat: "",
    street: "",
    postcode: "",
    city: "",
    email: "",
  });
  const [distancetext, setDistancetext] = useState(false);

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getBilldetail())();
    // eslint-disable-next-line
  }, [props?.language]);

  useEffect(()=>{
    getCartDetailsAPI();
    // eslint-disable-next-line
  },[]);

  async function getCartDetailsAPI() {
    let response = await getRequestcall(CART_DETAIL + `?lang=${props?.language?.toLowerCase()}`, props?.access_token);
    if (response?.status === 200) {
      const result = await response?.json();
      const OutOfStock = result?.data?.cart_products?.filter((item) => item?.out_of_stock !== false);
      // console.log("OutOfStock", OutOfStock,result?.data?.cart_products)
      if (OutOfStock?.length > 0 || result?.data?.cart_products?.length === 0) {
        window.history.replaceState({}, document.title)
        navigate("/cart");
      }
    }
  }

  const getBilldetail = () => {
    props?.fetchHeaderContent(t("pages.checkout.title"), "", "");
    setCardInput({
      ...cardInput,
      fullname: props?.logindata?.first_name,
      phone: props?.logindata?.mobile,
      email: props?.logindata?.email,
      lat: props?.currentLocation?.lat,
      lng: props?.currentLocation?.lng,
      address:
        props?.currentLocation?.selectedLocation === "" || typeof props?.currentLocation?.selectedLocation === "undefined"
          ? props?.currentLocation?.address
          : props?.currentLocation?.selectedLocation,
      city: props?.currentLocation?.city,
      country: props?.currentLocation?.country,
      flat: props.storeFlatstreet?.flat_no,
      street: props.storeFlatstreet?.street_name,
      postcode: props?.currentLocation?.zip_code,
      country_code: props?.logindata?.country_code,
    });
    if (props.navigatecheckout === "checkout") {
      props.maintanCheckoutpage("");
      getCartdetil();
    }
  };

  const getCartdetil = async () => {
    const getCartdetailapiresponse = await getRequestcall(
      CART_DETAIL+ `?lang=${props?.language?.toLowerCase()}`,
      props?.access_token,
    );
    if (getCartdetailapiresponse?.status === 200) {
      let getRes = await getCartdetailapiresponse.json();
      if (getRes?.data?.cart_products?.length > 0) {
        props.maintainCartdata(getRes?.data?.cart_products, props.amount); // store in redux for checkout and payment detail page
      }
    }
  };

  const changeInput = (e) => {
    setCardInput({
      ...cardInput,
      [e.target.name]: e.target.value,
    });
    let flatorstreet = {
      flat_no:
        e.target.name === "flat"
          ? e.target.value
          : props.storeFlatstreet?.flat_no,
      street_name:
        e.target.name === "street"
          ? e.target.value
          : props.storeFlatstreet?.street_name,
    };
    props.maintainFlatstreet(flatorstreet);
    setErrormsg({
      ...errorMsg,
      [e.target.name]: "",
    });
  };

  const locationValueChange = (value) => {
    setCardInput({
      ...cardInput,
      address: value,
    });
    setErrormsg({
      ...errorMsg,
      address: "",
    });
  };

  const SetLocation =async ({place, address, Lat, lng, ZipCode }) =>{
    let geturl =
    GET_DISTANCE +
    `?origin=${props?.storelocation?.store_address
      .split(" ")
      .join("")}&destination=${address?.split(" ").join("")}`;
  let getDistanceResponse = await getRequestcall(geturl, "");
  if (getDistanceResponse.status === 200) {
    let distance = await getDistanceResponse.json();
    let kilometer = distance?.rows[0]?.elements[0]?.distance?.value / 1000;
    if (kilometer > props?.storelocation?.delivery_max_distance) {
      setDistancetext(true);
    } else {
      setDistancetext(false);
    }
  }
   let zipCode = ZipCode
    let city = "";
    let country = "";
    place.address_components.forEach((item) => {
      switch (item.types[0]) {
        case "locality":
          city = item.long_name;
          break;
        case "country":
          country = item.long_name;
          break;
        default:
          break;
      }
    });
    setCardInput({
      ...cardInput,
      address: address,
      lat: Lat,
      lng: lng,
      city: city,
      country: country,
      postcode: zipCode,
    });
  }

  const validation = () => {
    let checkValue = true;
    if (cardInput.fullname === "") {
      errorMsg.fullname = "pages.checkout.fullname_warn";
      checkValue = false;
    }
    if (cardInput.address === "") {
      errorMsg.address = "pages.checkout.ulocation_warn";
      checkValue = false;
    }
    if (cardInput.country === "") {
      errorMsg.country = "pages.checkout.country_warn";
      checkValue = false;
    }
    if (cardInput.city === "") {
      errorMsg.city = "pages.checkout.town_warn";
      checkValue = false;
    }
    if (cardInput.flat === "" || typeof cardInput.flat === "undefined") {
      errorMsg.flat = "pages.checkout.flatno_warn";
      checkValue = false;
    }
    if (cardInput.street === "" || typeof cardInput.street === "undefined") {
      errorMsg.street = "pages.checkout.street_warn";
      checkValue = false;
    }
    if (cardInput.postcode === "") {
      errorMsg.postcode = "pages.checkout.postcode_warn";
      checkValue = false;
    }

    if (distancetext === true) {
      checkValue = false;
    }
    setErrormsg({
      fullname: errorMsg.fullname,
      address: errorMsg.address,
      country: errorMsg.country,
      flat: errorMsg.flat,
      street: errorMsg.street,
      postcode: errorMsg.postcode,
      city: errorMsg.city,
    });
    if (checkValue === true) {
      return true;
    } else {
      return false;
    }
  };

  const navigateTopayment = () => {
    if (validation()) {
      if (props?.cartdata?.length > 0) {
        navigate("/payment", { state: { cardInput: cardInput } });
      } else {
        toast.error(t("pages.Your cart is empty please add to cart product"));
      }
    }
  };

  return (
    <aside className="checkout ">
      <BannercartPage title={"pages.checkout.title"}/>
      <div className="container pt-4 pb-4">
        <div className="row">
          <div className="col-xl-9 mt-3 order-card">
            <div className="card">
              <div className="card-body">
                <h5 className="header-title pr-color">
                  {t("pages.checkout.subtitle")}
                </h5>
                <Form method={"post"} className="mt-4 row card-form">
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.fullname")}
                      placeholder={t("pages.checkout.fullname_place")}
                      value={cardInput.fullname}
                      name={"fullname"}
                      type={"text"}
                      onChange={changeInput}
                      error={t(errorMsg.fullname)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.company_name")}
                      value={cardInput.company_name}
                      onChange={changeInput}
                      name={"company_name"}
                      placeholder={t("pages.checkout.company_name_place")}
                      type={"text"}
                      require={false}
                      error={""}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormLabel label={t("pages.checkout.ulocation")}/>
                    <AutocompletePlace 
                      setAddress={locationValueChange}
                      address={cardInput?.address}
                      placaddress={t("pages.setupstore.address_place")}
                      SetLocation={SetLocation}
                      className={"bussinesssetup-location"}
                    />
                    <span className="warning text-danger">
                      {distancetext
                        ? "This store does not deliver here"
                        : t(errorMsg.address)}
                    </span>
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.country")}
                      value={cardInput.country}
                      onChange={changeInput}
                      name={"country"}
                      id={"country"}
                      placeholder={t("pages.checkout.country_warn")}
                      type="text"
                      error={t(errorMsg.country)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.town")}
                      value={cardInput.city}
                      onChange={changeInput}
                      name={"city"}
                      id={"city"}
                      placeholder={t("pages.checkout.town_place")}
                      error={t(errorMsg.city)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.flatno")}
                      value={cardInput.flat}
                      onChange={changeInput}
                      name={"flat"}
                      placeholder={t("pages.checkout.flatno_place")}
                      type="text"
                      error={t(errorMsg.flat)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.street")}
                      value={cardInput.street}
                      onChange={changeInput}
                      name={"street"}
                      id={"street"}
                      placeholder={t("pages.checkout.street_place")}
                      type="text"
                      error={t(errorMsg.street)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormgroupPage 
                      label={t("pages.checkout.postcode")}
                      value={cardInput.postcode}
                      onChange={changeInput}
                      name={"postcode"}
                      placeholder={t("pages.checkout.postcode_place")}
                      type="text"
                      error={t(errorMsg.postcode)}
                    />
                  </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormLabel label={t("pages.checkout.phone")}/>
                    <FormControl placeholder={t("pages.checkout.postcode_place")} value={props?.logindata?.country_code === "+91"
                          ? props?.logindata?.country_code +
                            " " +
                            formatPhoneNumber(cardInput.phone)
                          : props?.logindata?.country_code +
                            " " +
                            formatPhoneNumberturkish(cardInput.phone)} name={"phone"} disabled={true}/>
                   </div>
                  <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-col">
                    <FormLabel label={t("pages.checkout.email_address")}/>
                    <FormControl 
                     placeholder={t("pages.checkout.email_address_warn")} 
                     value={cardInput.email} name={"email"} disabled={true}/>
                  </div>
                  <div
                    className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 "
                    hidden
                  >
                    <Form.Check
                      className="check_option"
                      id="option 1"
                      label={t("pages.checkout.ship_address")}
                    />
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="col-xl-3 mt-3">
           <div className="order-card">
             <CurrentorderlistPage cartdata={props?.cartdata} />
              <OrdersummaryPage amount={props?.amount}/>
              <div className="mt-4">
              <ButtonPage Text={t("pages.checkout.submit")}  onClick={() => navigateTopayment()} className={`button-submit w-100 rounded`} type={"submit"} /> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}

const mapStateToProps = (state) => ({
  logindata: state?.login?.logindata,
  currentLocation: state?.home?.currentLocation,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  storelocation: state?.home?.storelocation,
  navigatecheckout: state?.home?.navigatecheckout,
  access_token: state?.login?.access_token,
  storeFlatstreet: state?.home?.storeFlatstreet,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  maintainCartdata,
  maintanCheckoutpage,
  maintainFlatstreet,
  fetchHeaderContent,
})(CheckoutPage);
